(function($){
    $('.DataCenterSlider-slider').slick({
        dots: true,
        prevArrow: '<button type="button" class="DataCenterSlider-button DataCenterSlider-button--prev slick-prev">Previous</button>',
        nextArrow: '<button type="button" class="DataCenterSlider-button DataCenterSlider-button--next slick-next">Next</button>',
        mobileFirst: true,
        dotsClass: 'DataCenterSlider-dots',
    });

}(jQuery));

